import FinanceAdapter from './base';

export default class LedgerItem extends FinanceAdapter {
  modelNamePlural = 'ledgerItems';
}
